<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="businessIntranet/findLegalRecordList.action"
                    ref="intranetLegalRecordTable">
      <template slot="search">
        <el-row>
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-date-picker
                  @change="onDateTimeChange"
                  end-placeholder="结束日期"
                  range-separator="至"
                  start-placeholder="开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndTime">
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button @click="$refs.intranetLegalRecordTable.search()" type="primary">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-row>

      </template>
      <template slot="item">

        <el-table-column
                label="创建时间"
        >
          <template scope="scope">
            {{scope.row.createTime|dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column
                label="类型"
                prop="typeName">
        </el-table-column>

        <el-table-column
                label="次数"
                prop="count">
        </el-table-column>

        <el-table-column
            label="备注"
            prop="remark">
        </el-table-column>

      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'intranetLegalRecord',
  data: function () {
    return {
      queryParams: {
        businessId: null
      }
    }
  },
  created () {
    let query = this.$route.query
    this.queryParams.businessId = query.businessId
  },
  methods: {
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.intranetLegalRecordTable.search()
    }
  },
  filters: {

  }
}
</script>

<style scoped>
</style>
